export function EFCheckBlankIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1.37173'
        y='1.59731'
        width='21.0835'
        height='21.0835'
        rx='2.10835'
        stroke='#E0E0E0'
        strokeWidth='1.40556'
      />
    </svg>
  )
}
